export const FINISHED_GOOD_DETAILS_STEP = 0;

export const FINISHED_GOOD_QUESTIONS_STEP = 1;

export const COMPONENT_DETAILS_STEP = 2;

export const COMPONENT_QUESTIONS_STEP = 3;

export const SUBMISSION_STEP = 4;
